import React from 'react';
import { AppStore } from '../definitions/types';
import { RouteObject } from 'react-router-dom';
import { APP_PATHS } from './route-helpers';
import DomainView from '../views/domainView/domainView';
import IndustryView from '../views/industryView/industryView';
import ProductChoiceView from '../views/productChoiceView';
import PricingView from '../views/pricingView/pricingView';
import TemplateView from '../views/templateView/templateView';
import getConfig from '../config';
import { isAustraliaCountry, isUserAllowedToEnterDolphin } from '../modules/helpers';
import { PRODUCT_TYPE_CREATOR } from '../modules/constants';
import { forwardToDolphinCms } from '../redux/actions/dolphin-cms';
import { ValidProductType } from '../redux/reducers/intent';

// Runs before the product choice view renders, as its onEnter hook did in React Router 3.
export const handleProductChoicePerLanguage = (store: AppStore) => (): Promise<null> | null => {
  const state = store.getState();
  const { ref } = state.affiliate;
  const { skipTemplateView } = state.template;
  const { country } = getConfig();
  const hasPreselectedCreator = state.intent.preSelectedProduct === (PRODUCT_TYPE_CREATOR as ValidProductType);
  const allowedToEnterDolphin = isUserAllowedToEnterDolphin(
    ref,
    skipTemplateView,
    hasPreselectedCreator
  );

  if (allowedToEnterDolphin && isAustraliaCountry(country)) {
    store.dispatch(forwardToDolphinCms());

    // The browser is leaving for the Dolphin CMS, so the view never renders.
    return new Promise<null>(() => undefined);
  }

  return null;
};

export const getAppRoutes = (store: AppStore): RouteObject[] => [
  {
    path: APP_PATHS.PRODUCT,
    element: <ProductChoiceView route={{ path: APP_PATHS.PRODUCT }} />,
    loader: handleProductChoicePerLanguage(store),
  },
  {
    path: APP_PATHS.INDUSTRY,
    element: <IndustryView route={{ path: APP_PATHS.INDUSTRY }} />,
  },
  {
    path: APP_PATHS.TEMPLATE,
    element: <TemplateView route={{ path: APP_PATHS.TEMPLATE }} />,
  },
  {
    path: APP_PATHS.PRICING,
    element: <PricingView />,
  },
  {
    path: APP_PATHS.DOMAIN,
    element: <DomainView />,
  },
];
